module.exports = __webpack_public_path__ + "static/media/p-logo-applepay.aac04127.svg";